
import { Component, Vue } from 'vue-property-decorator';
import { login } from '@/utils/auth';
import Form from '@/components/Form/Form.vue';
import InputField from '@/types/InputField';
import * as constants from './constants';

@Component({
  components: {
    Form,
  },
})

export default class LoginForm extends Vue {
  public username: string = '';
  public password: string = '';
  public error: string | null = null;
  public constants: object = constants;
  public loginFields: InputField[] = [
    {
      placeholder: constants.USERNAME_PLACEHOLDER,
      updateInput: this.updateUsername,
      type: 'text',
      key: constants.USERNAME_PLACEHOLDER,
    },
    {
      placeholder: constants.PASSWORD_PLACEHOLDER,
      updateInput: this.updatePassword,
      type: 'password',
      key: constants.PASSWORD_PLACEHOLDER,
    },
];


  public updateUsername(input: string): void {
    this.username = input;
  }

  public updatePassword(input: string): void {
    this.password = input;
  }

  public async login(): Promise<void> {
    this.error = null;
    try {
      await login(this.username, this.password);
    } catch (error) {
      this.error = error.message;
    }
  }
}
